import { useIntl } from 'react-intl';

import { SubmitButton } from '@/components/signup/site-activation/components/common/submit-button';

export const SubmitButtonMessageNext = () => {
	const intl = useIntl();

	const submitMessage = intl.formatMessage({
		id: 'WacSignupForm.upgradeButtonText.messageNext',
		defaultMessage: 'Next',
	});

	return <SubmitButton submitMessage={submitMessage} />;
};
